/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'

/**
 * Typescript enum
 */

export enum GameTag {
  finished = 'finished',
  paused = 'paused',
  playing = 'playing',
  pregame = 'pregame',
  readytoplay = 'readytoplay',
  reset = 'reset',
  sleep = 'sleep'
}

/**
 * GameTag
 *
 * The possible Game States
 */
export const GameTagEnumType = types.enumeration('GameTag', [
  'finished',
  'paused',
  'playing',
  'pregame',
  'readytoplay',
  'reset',
  'sleep'
])
